<template>
  <div style="width: 1000px">
    <a-form-item label="生效页面">
      <a-select
        v-model:value="initState.effectivePageIds"
        style="width: 100%"
        :disabled="initState.allSitePage === 1"
        mode="multiple"
      >
        <a-select-option
          v-for="item in initState.effectivePageList"
          :key="item.pageId"
          :value="item.pageId"
          >{{ item.pageName }}</a-select-option
        >
      </a-select>
    </a-form-item>
    <a-form-item label="指定页面" v-if="initState.terminalId === 1">
      <a-space>
        <a-input
          :disabled="initState.allSitePage === 1"
          v-model:value="state.link"
          style="width: 360px;"
          placeholder="请输入链接/路由"
        />
        <a-button
          :disabled="initState.allSitePage === 1"
          type="primary"
          @click="state.handleAddSpecifyPage"
          >添加</a-button
        >
      </a-space>
    </a-form-item>
    <a-form-item label=" " :colon="false" v-if="initState.specifyPages.length">
      <div
        style="width: 100%; display: flex; align-items: center; margin-bottom: 10px;"
        v-for="(item, index) in initState.specifyPages"
        :key="index"
      >
        <a-input style="width: 360px;" :value="item" readonly></a-input>
        <DeleteOutlined
          style="margin-left: 20px; cursor: pointer;"
          @click="initState.removeSpecifyPage(index)"
        />
      </div>
    </a-form-item>
    <a-form-item label="全站页面" v-if="initState.terminalId === 1">
      <a-checkbox
        :checked="initState.allSitePage === 1"
        @change="onAllSitePageChange"
      >
      </a-checkbox>
    </a-form-item>
    <a-form-item label="生效人群">
      <a-select
        v-model:value="initState.personGroup"
        :disabled="!initState.editable"
      >
        <a-select-option :value="2">全部用户</a-select-option>
        <a-select-option :value="999">指定用户群</a-select-option>
        <a-select-option :value="1" v-if="initState.terminalId === 1">
          新访
        </a-select-option>
        <a-select-option :value="0" v-if="initState.terminalId === 1">
          老访
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label=" " :colon="false" v-if="initState.personGroup === 999">
      <a-space>
        <a-button
          type="primary"
          @click="state.handleShowUserGroup"
          v-if="initState.editable"
        >
          指定用户群
        </a-button>
        <a-button @click="state.handleViewUserGroup">
          查看已选用户
        </a-button>
      </a-space>
    </a-form-item>
    <a-form-item label="人群行为">
      <Condition />
    </a-form-item>
    <a-form-item label="触发时间">
      <a-select placeholder="请选择条件" v-model:value="initState.triggerTime">
        <a-select-option :value="0">立即</a-select-option>
        <a-select-option :value="1">二次进站</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="触发频次">
      <a-radio-group v-model:value="initState.triggerFrequency">
        <a-radio :value="1">仅1次</a-radio>
        <a-radio :value="0">间隔天数:</a-radio>
      </a-radio-group>
      <a-input-number
        v-model:value="initState.intervalDays"
        :disabled="initState.triggerFrequency !== 0"
        :precision="0"
        :max="99"
        :min="1"
      ></a-input-number>
      <span style="display: inline-block; margin: 0 20px;">弹出次数:</span>
      <a-input-number
        v-model:value="initState.popupCount"
        :precision="0"
        disabled
        :max="99"
        :min="1"
      >
      </a-input-number>
    </a-form-item>
    <a-form-item
      label="优先级"
      extra="同一时间，同一生效页面，数值越大，优先级越高"
    >
      <a-input-number
        v-model:value="initState.priority"
        :max="999"
        :precision="0"
        :min="1"
      ></a-input-number>
    </a-form-item>
  </div>
  <div style="display: flex; justify-content: flex-end;">
    <a-space>
      <a-button type="primary" @click="next">下一步</a-button>
      <a-button @click="initState.prev">上一步</a-button>
    </a-space>
  </div>
  <a-drawer
    title="指定用户群"
    v-model:visible="state.visible"
    placement="right"
    width="70%"
    destroyOnClose
  >
    <template #extra>
      <a-space>
        <a-button v-if="state.mode === 'select'" @click="state.visible = false">
          取消
        </a-button>
        <a-button type="primary" @click="state.handleSelectUserGroup">
          确定
        </a-button>
      </a-space>
    </template>
    <a-form
      v-if="state.mode === 'select'"
      layout="inline"
      style="margin-bottom: 30px;"
    >
      <a-form-item>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="用户群ID">
              <a-input
                v-model:value="state.groupParams.id"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="用户群名称">
              <a-input
                v-model:value="state.groupParams.name"
                placeholder="请输入"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-space>
              <a-button @click="state.reset">重置</a-button>
              <a-button type="primary" @click="state.initList(1)">
                查询
              </a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>
    <a-table
      :columns="state.columns"
      rowKey="id"
      bordered
      :pagination="false"
      :rowSelection="state.mode === 'select' ? state.rowSelection : false"
      :dataSource="dataSource"
    ></a-table>
    <div class="pagination" v-if="state.mode === 'select'">
      <a-pagination
        :showTotal="total => `共 ${total}条数据`"
        v-model:current="state.pagination.pageNum"
        v-model:pageSize="state.pagination.pageSize"
        :total="state.pagination.total"
        showSizeChanger
        @change="state.initList"
      />
    </div>
  </a-drawer>
</template>

<script setup>
import { reactive, inject, watch, computed } from 'vue'
import { DeleteOutlined } from '@ant-design/icons-vue'
import { usePagination } from '@/utils/useCommon'
import { get_users_group } from '@/server/modules/17209'
import Condition from './Condition.vue'
import { message } from 'ant-design-vue'

const initState = inject('initState')

const state = reactive({
  link: '',
  pagination: usePagination(),
  mode: '',
  visible: false,
  dataSource: [],
  columns: [
    {
      title: '用户群ID',
      dataIndex: 'id',
      key: 'id',
      width: '40%'
    },
    {
      title: '用户群名称',
      dataIndex: 'name',
      key: 'name',
      width: '60%'
    }
  ],
  rowSelection: {
    hideSelectAll: true,
    selectedRowKeys: initState.personGroupId ? [initState.personGroupId] : [],
    onSelect: (record, selected) => {
      state.rowSelection.selectedRowKeys = selected ? [record.id] : []
    }
  },
  groupParams: {
    id: [],
    name: ''
  },
  reset: () => {
    state.groupParams.id = ''
    state.groupParams.name = ''
    state.initList(1)
  },
  initList: async (pageNum, pageSize) => {
    if (pageNum) {
      state.pagination.pageNum = pageNum
    }
    if (pageSize) {
      state.pagination.pageSize = pageSize
    }
    const params = {
      brandId: initState.brandId,
      channelId: initState.channelId,
      siteId: initState.siteId,
      terminalId: initState.terminalId,
      ...state.groupParams,
      pageNum: state.pagination.pageNum,
      pageSize: state.pagination.pageSize
    }
    if (state.mode === 'view') {
      params.id = initState.personGroupId
    }
    const { data } = await get_users_group(params)
    state.dataSource = data.list
    state.pagination.total = data.total
  },
  handleSelectUserGroup: () => {
    if (state.mode === 'view') {
      state.visible = false
      return
    }
    if (!state.rowSelection.selectedRowKeys.length) {
      return message.warn('请选择用户群')
    }
    state.visible = false
    initState.personGroupId = state.rowSelection.selectedRowKeys[0]
  },
  handleShowUserGroup: () => {
    state.mode = 'select'
    state.visible = true
  },
  handleViewUserGroup: () => {
    state.mode = 'view'
    state.visible = true
  },
  handleAddSpecifyPage: () => {
    if (!state.link) {
      return message.warn('请输入链接/路由')
    }

    if (initState.terminalId === 1 && !state.link.startsWith('https://')) {
      return message.warn('请输入正确的链接')
    }

    initState.specifyPages.push(state.link)
    state.link = ''
  }
})

const dataSource = computed(() => {
  if (state.mode === 'view') {
    return state.dataSource.filter(
      item => item.id === state.rowSelection.selectedRowKeys[0]
    )
  }

  return state.dataSource
})

watch(
  () => state.visible,
  value => {
    if (value) {
      state.initList()
    } else {
      state.dataSource = []
      state.pagination.pageNum = 1
      state.pagination.pageSize = 10
      state.pagination.total = 0
      state.groupParams.id = ''
      state.groupParams.name = ''
    }
  }
)

const onAllSitePageChange = event => {
  initState.allSitePage = event.target.checked ? 1 : 0
}

const next = () => {
  if (initState.allSitePage !== 1) {
    if (
      initState.effectivePageIds.length + initState.specifyPages.length ===
      0
    ) {
      return message.warn('请选择生效页面')
    }
  }
  if (initState.personGroup === null) {
    return message.warn('请选择生效人群')
  }
  if (initState.personGroup === 999 && initState.personGroupId === null) {
    return message.warn('请选择用户群')
  }
  if (!initState.ruleConditions.length) {
    return message.warn('请选择人群行为')
  }
  if (
    initState.ruleConditions.some(item => {
      return (
        item.conditionKey === null ||
        item.conditionValue === null ||
        item.conditionOperationSymbols === null
      )
    })
  ) {
    return message.warn('请输入完整的人群行为规则')
  }
  if (initState.triggerTime === null) {
    return message.warn('请选择触发时间')
  }
  if (initState.triggerFrequency === null) {
    return message.warn('请选择触发频率')
  }
  if (initState.intervalDays === null && initState.triggerFrequency === 0) {
    return message.warn('请输入间隔天数')
  }
  if (initState.popupCount === null && initState.triggerFrequency === 0) {
    return message.warn('请输入弹出次数')
  }
  if (initState.priority === null) {
    return message.warn('请输入优先级')
  }
  initState.next()
}
</script>
<style scoped>
.pagination {
  display: flex;
  flex-direction: row-reverse;
  background: #fff;
  padding: 20px;
}
</style>
